import { PracticeManagement } from "components/features/practice";
import React from "react";

const PracticeManagementPage: React.FC = () => {
  return <PracticeManagement />;
};

export default PracticeManagementPage;
